export const catalog = [
  {
    code: "CP91L",
    name: "Port & Company Beanie",
    fullname: "Port & Company® Fleece-Lined Beanie Cap",
    colors: ["Athletic Red", "Athletic Royal", "Black","Navy"],
    type: "mens",
    default_color: "Black",
    sizes: {
      OSFA: 0.00,
    },
  },
  {
    code: "112",
    name: "Richardson Trucker Cap",
    fullname: "Richardson Snapback Trucker Cap (addt'l logos cost extra)",
    colors: ["Amber Gold","Black","Charcoal","Loden","Maroon","Navy","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      OSFA: 0.00,
    },
  },
  {
    code: "NE205",
    name: "New Era® Trucker Cap",
    fullname: "New Era® Snapback Trucker Cap (addt'l logos cost extra)",
    colors: ["Black","Graphite","Grey","Deep Navywt"],
    type: "mens",
    default_color: "Black",
    sizes: {
      OSFA: 0.00,
    },
  },
  {
    code: "STC39",
    name: "Sport-Tek® Trucker Cap",
    fullname: "Sport-Tek® YP Classics® Retro Trucker Cap (addt'l logos cost extra)",
    colors: ["Black","Graphite","True Navy True Navy","True Navy White","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      OSFA: 0.00,
    },
  },
  {
    code: "BB18000",
    name: "Brooks Brothers® Shirt",
    fullname: "Brooks Brothers® Wrinkle-Free Stretch Pinpoint Shirt",
    colors: ["Cobalt Blue", "Deep Black","Newport Blue","White"],
    type: "mens",
    default_color: "Cobalt Blue",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "BB18002",
    name: "Brooks Brothers® Shirt",
    fullname: "Brooks Brothers® Wrinkle-Free Nailhead Shirt",
    colors: ["Cobalt Blue", "White"],
    type: "mens",
    default_color: "Cobalt Blue",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "BB18003",
    name: "Brooks Brothers® Shirt",
    fullname: "Brooks Brothers® Women's Wrinkle-Free Nailhead Shirt",
    colors: ["Cobalt Blue", "White"],
    type: "womens",
    default_color: "Cobalt Blue",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "S659",
    name: "Port Authority® Shirt",
    fullname: "Port Authority® Short Sleeve SuperPro™ Oxford Shirt",
    colors: ["Black", "Navy","Oxford Blue","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "S608",
    name: "Port Authority® Shirt",
    fullname: "Port Authority® Long Sleeve Easy Care Shirt",
    colors: ["White"],
    type: "mens",
    default_color: "White",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
      "5XLarge": 0.00,
      "6XLarge": 0.00,
    },
  },
  {
    code: "L608",
    name: "Port Authority® Shirt",
    fullname: "Port Authority® Women's Long Sleeve Shirt",
    colors: ["White"],
    type: "womens",
    default_color: "White",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
      "5XLarge": 0.00,
      "6XLarge": 0.00,
    },
  },
  {
    code: "PC61",
    name: "Port & Company® Tee",
    fullname: "Port & Company® Essential Tee",
    colors: ["Athletic Heather","Cardinal","Charcoal","Jet Black",
      "Medium Grey","Navy","Red","Royal","White"],
    type: "mens",
    default_color: "Jet Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
      "5XLarge": 0.00,
      "6XLarge": 0.00,
    },
  },
  {
    code: "ST650",
    name: "Sport-Tek® Polo Shirt",
    fullname: "Sport-Tek® Micropique Polo",
    colors: ["Black", "Grey Concrete", "Iron Grey", "True Red"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
      "5XLarge": 0.00,
      "6XLarge": 0.00,
    },
  },
  {
    code: "LST650",
    name: "Sport-Tek® Polo Shirt",
    fullname: "Sport-Tek® Womens Micropique Polo",
    colors: ["Black", "Grey Concrete", "Iron Grey", "True Red"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "267020",
    name: "Nike® Dri-FIT Classic Polo",
    fullname: "Nike® Dri-FIT Classic Polo",
    colors: ["Black","Court Blue","Light Blue","Midnight Navy","Varsity Red","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 40.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,     
    },
  }, 
  {
    code: "883681",
    name: "Nike® Dri-FIT Legacy Polo",
    fullname: "Nike® Dri-FIT Legacy Polo (addt'l logos cost extra)",
    colors: ["Black","Dark Grey","Game Royal","Gym Red","Light Photo Blue","Midnight Navy"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,     
    },
  },  
  {
    code: "NKDC1991",
    name: "Ladies Nike® Polo",
    fullname: "Ladies Nike® Micro Pique Polo",
    colors: ["Anthracite", "Black", "University Red"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
    },
  },
  {
    code: "NKDC1963",
    name: "Nike® Dri-FIT Polo Shirt",
    fullname: "Nike Dri-FIT Micro Pique 2.0 Polo",
    colors: ["Anthracite", "Black", "University Red"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
      LT: 0.00,
      XLT: 0.00,
      "2XLT": 0.00,
      "3XLT": 0.00,
      "4XLT": 0.00,
    },
  },
  {
    code: "NKAH6266",
    name: "Nike Textured Polo",
    fullname: "Nike Dri-FIT Hex Textured Polo",
    colors: ["Black","Court Blue","Dark Grey","Game Royal","Gym Red","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00, 
      "3XLarge": 0.00,
      "4XLarge": 0.00,  
    },
  },
  {
    code: "NKBV6042",
    name: "Nike® Essential Polo",
    fullname: "Nike® Dry Essential Solid Polo",
    colors: ["Black", "Game Royal", "Midnight Navy","University Blue", "University Red", "White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,     
    },
  },
   {
    code: "TM1MY399",
    name: "TravisMathew Polo",
    fullname: "TravisMathew Bayfront Solid Polo",
    colors: ["Black","Dark Grey","Insignia Blue","Roan Rouge"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,          
    },
  },
  {
    code: "TM1MU410",
    name: "TravisMathew Performance Polo",
    fullname: "TravisMathew Coto Performance Polo",
    colors: ["Beryl Grn Hthr","Black","Blue Nights","Brilliant Blue Hthr","Federal Blue",
    "Quiet Shade Gry Hthr","Quiet Shade Gry Blk","Vintage Indigo Blk","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,          
    },
  },
  {
    code: "OG101",
    name: "OGIO® - Caliber2.0 Polo",
    fullname: "OGIO® - Caliber2.0 Polo",
    colors: ["Blacktop"],
    type: "mens",
    default_color: "Blacktop",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "LOG101",
    name: "OGIO® - Jewel Polo",
    fullname: "OGIO® - Jewel Polo",
    colors: ["Blacktop"],
    type: "womens",
    default_color: "Blacktop",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "TM1WW003",
    name: "TravisMathew 1/4-Zip",
    fullname: "TravisMathew Women's Crestview 1/4-Zip",
    colors: ["Black"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,      
    },
  },
  {
    code: "K110",
    name: "Port Authority UV Polo",
    fullname: "Port Authority® Dry Zone® UV Micro-Mesh Polo",
    colors: ["Carolina Blue","Coastal Blue","Deep Black","Graphite",
    "Gusty Grey","Rich Red","River Blue Navy","True Royal","White"],
    type: "mens",
    default_color: "Deep Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
      "5XLarge": 0.00,
      "6XLarge": 0.00,
    },
  },
  {
    code: "ST350",
    name: "Sport-Tek PosiCharge Tee",
    fullname: "Sport-Tek PosiCharge Competitor Tee",
    colors: ["Black"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "ST740",
    name: "Sport-Tek Polo",
    fullname: "Sport-Tek® UV Micropique Polo",
    colors: ["Black","Deep Red","Graphite","Grey Concrete",
      "True Navy","True Royal","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "PC61LS",
    name: "Long Sleeve Tee",
    fullname: "Port & Company® Long Sleeve Essential Tee",
    colors: ["Ash", "Athletic Heather", "Cardinal", "Charcoal", 
      "Deep Navy","Jet Black","Navy","Red","Royal","White"],
    type: "mens",
    default_color: "Jet Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "PC90H",
    name: "Hooded Sweatshirt",
    fullname: "Port & Company® Essential Fleece Pullover Hooded Sweatshirt",
    colors: ["Athletic Heather","Cardinal","Charcoal",
      "Drk Hthr Gry","Jet Black","Navy","Red","Royal","White"],
    type: "mens",
    default_color: "Jet Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "F700",
    name: "Raglan Fleece",
    fullname: "Port Authority® C-FREE® Raglan Fleece",
    colors: ["Deep Black", "Grey Steel", "True Navy"],
    type: "mens",
    default_color: "Deep Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "TM1MZ339",
    name: "TravisMathew 1/4-Zip",
    fullname: "TravisMathew Coveside 1/4-Zip",
    colors: ["Black", "Blue Nights", "Drk Gry Hthr", "Light Blue Hthr"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,           
    },
  },  
  {
    code: "K805",
    name: "Port Authority® 1/4-Zip Pullover",
    fullname: "Port Authority® 1/4-Zip Pullover",
    colors: ["Black", "Iron Grey"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "L805",
    name: "Port Authority® Pullover",
    fullname: "Port Authority® Women's Vertical Texture Full-Zip Jacket",
    colors: ["Black", "Iron Grey", "Regatta Blue", "True Navy"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
   {
    code: "J317",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Core Soft Shell Jacket",
    colors: ["Black", "Battleship Grey"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
      "5XLarge": 0.00,
      "6XLarge": 0.00,
    },
  },
  {
    code: "L317",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Ladies Core Soft Shell Jacket",
    colors: ["Battleship Grey", "Black"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,
    },
  },
  {
    code: "J333",
    name: "Torrent Waterproof Jacket",
    fullname: "Port Authority® Torrent Waterproof Jacket",
    colors: ["Black", "Engine Red","Magnet","True Navy","True Royal"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,     
    },
  },
  {
    code: "NKDR1543",
    name: "Nike® Hooded Jacket",
    fullname: "Nike® Hooded Soft Shell Jacket",
    colors: ["Black"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,     
    },
  },
  {
    code: "J335",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Hooded Core Soft Shell Jacket",
    colors: ["Black"],
    type: "mens",
    default_color: "Black",
    sizes: {
      XSmall: 0.00,
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,     
    },
  },
  {
    code: "L335",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Women's Hooded Core Soft Shell Jacket",
    colors: ["Black"],
    type: "womens",
    default_color: "Black",
    sizes: {
      XSmall: 0.00,
      Small: 0.00,
      Medium: 0.00,
      Large: 0.00,
      XLarge: 0.00,
      "2XLarge": 0.00,
      "3XLarge": 0.00,
      "4XLarge": 0.00,     
    },
  },
  {
    code: "GP546",
    name: "Deal Jackets",
    fullname: "Deal Jackets - Plain",
    colors: [
      "Blue",
      "Buff",
      "Fuchsia",
      "Green",
      "Grey",
      "Lavender",
      "Pink",
      "Salmon",
      "White",
      "Yellow",
    ],
    type: "sales",
    default_color: "Blue",
    discount: [{ quantity: 100, price: 0.00 },
               { quantity: 500, price: 0.00 }],
    sizes: {
      100: 0.00,
      500: 0.00,
    },
  },
  {
    code: "5470",
    name: "A/P Voucher Jacket",
    fullname: "9 in. x 12 in. A/P Voucher Jacket (DSA-540)",
    colors: ["Blue", "Buff", "Green", "Lavender", "Pink", "White"],
    type: "sales",
    default_color: "Buff",
    sizes: {
      100: 0.0,
      500: 0.0,
    },
  },
  {
    code: "GP200",
    name: "Key Tags",
    fullname: "Key Tag Versa #200 (250/box)",
    colors: [
      "Blue",
      "Gray",
      "Green",
      "Lilac",
      "Lime Green",
      "Orange",
      "Red",
      "Tan",
      "White",
      "Yellow",
    ],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 250, price: 0.00 }],
    sizes: {
      250: 0.0,
    },
  },
  {
    code: "VT400",
    name: "Stock Stickers",
    fullname: "Kleer-Back Stock Stickers Versa #400 (100/pk)",
    colors: ["Blue", "Green", "Orange", "Red", "White", "Yellow"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 100, price: 0.00 }],
    sizes: {
      100: 0.0,
    },
  }, 
  {
    code: "250",
    name: "Poly Key Tag",
    fullname: "Poly Tag Key Tag #250 (250/box)",
    colors: ["White", "Yellow"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 250, price: 0.00 }],
    sizes: {
      250: 0.0,
    },
  }, 
  {
    code: "240",
    name: "Poly Stock Stickers",
    fullname: "Poly Stock Stickers #240 (250/box)",
    colors: ["White", "Yellow"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 250, price: 0.00 }],
    sizes: {
      250: 0.0,
    },
  }, 
  {
    code: "226",
    name: "Combo Key Tags",
    fullname: "Combo Key Tags - Numbered (125/box)",
    colors: ["Beige","Blue","Green","Grey","Lilac",
      "Orange","Red","White","Yellow"],   
    type: "sales",
    default_color: "Beige",
    discount: [{ quantity: 125, price: 0.00 }],
    sizes: {
      125: 0.00,
    },
  }, 
  {
    code: "DKTB",
    name: "Stock-In Numbers",
    fullname: "Stock-In Numbers (250/pk)",
    colors: ["White"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 250, price: 0.00 }],
    sizes: {
      250: 0.00,
    },
  }, 
   {
    code: "650B",
    name: "Stock Number Signs",
    fullname: "Stock Number Mini Signs 6in x 3in #650 (250/pk)",
    colors: ["White", "Yellow"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 250, price: 0.00 }],
    sizes: {
      250: 0.00,
    },
  }, 
  {
    code: "225",
    name: "Top Stripe Key Tags",
    fullname: "Top Stripe Key Tags #225 (250/pk)",
    colors: ["Black","Blue","Green","Magenta","Orange","Red","Yellow"],
    type: "sales",
    default_color: "Black",
    discount: [{ quantity: 250, price: 0.00 }],
    sizes: {
      250: 0.00,
    },
  },
  {
    code: "30BKHP",
    name: "7.5 in. Numbers - Bk/Htpk",
    fullname: "7.5 in. Numbers - Black/Hot Pink (12/pk)",
    colors: ["BKHP0","BKHP1","BKHP2","BKHP3","BKHP4","BKHP5","BKHP6","BKHP7","BKHP8","BKHP9","BKHPS","BKHPD","BKHPP"],
    type: "sales",
    default_color: "BKHP0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "30SLBK",
    name: "7.5 in. Numbers - Slv/Blk",
    fullname: "7.5 in. Numbers - Silver/Black (12/pk)",
    colors: ["SLBK0","SLBK1","SLBK2","SLBK3","SLBK4","SLBK5","SLBK6","SLBK7","SLBK8","SLBK9","SLBKS","SLBKD","SLBKP"],
    type: "sales",
    default_color: "SLBK0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "30GDBK",
    name: "7.5 in. Numbers - Gld/Blk",
    fullname: "7.5 in. Numbers - Gold/Black (12/pk)",
    colors: ["GDBK0","GDBK1","GDBK2","GDBK3","GDBK4","GDBK5","GDBK6","GDBK7","GDBK8","GDBK9","GDBKS","GDBKD","GDBKP"],
    type: "sales",
    default_color: "GDBK0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "30CBK",
    name: "7.5 in. Numbers - Char/Blk",
    fullname: "7.5 in. Numbers - Chartreuse/Black (12/pk)",
    colors: ["CBK0","CBK1","CBK2","CBK3","CBK4","CBK5","CBK6","CBK7","CBK8","CBK9","CBKS","CBKP"],
    type: "sales",
    default_color: "CBK0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "30YBK",
    name: "7.5 in. Numbers - Ylw/Blk",
    fullname: "7.5 in. Numbers - Yellow/Black (12/pk)",
    colors: ["YBK0","YBK1","YBK2","YBK3","YBK4","YBK5","YBK6","YBK7","YBK8","YBK9","YBKS","YBKP", "YBKD"],
    type: "sales",
    default_color: "YBK0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "30YR",
    name: "7.5 in. Numbers - Yllw/Red",
    fullname: "7.5 in. Numbers - Yellow/Red (12/pk)",
    colors: ["YR0","YR1","YR2","YR3","YR4","YR5","YR6","YR7","YR8","YR9","YRS","YRP","YRD"],
    type: "sales",
    default_color: "YR0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
   {
    code: "30YGR",
    name: "7.5 in. Numbers - Yllw/Grn",
    fullname: "7.5 in. Numbers - Yellow/Green (12/pk)",
    colors: ["YGR0","YGR1","YGR2","YGR3","YGR4","YGR5","YGR6","YGR7","YGR8","YGR9","YGRS","YGRP","YGRD"],
    type: "sales",
    default_color: "YGR0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "30YB",
    name: "7.5 in. Number - Yllw/Blue",
    fullname: "7.5 in. Numbers - Yellow/Blue (12/pk)",
    colors: ["YB0","YB1","YB2","YB3","YB4","YB5","YB6","YB7","YB8","YB9","YBS","YBP","YBD"],
    type: "sales",
    default_color: "YB0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "30WB",
    name: "7.5 in. Number - Wht/Blue",
    fullname: "7.5 in. Numbers - White/Blue (12/pk)",
    colors: ["WB0","WB1","WB2","WB3","WB4","WB5","WB6","WB7","WB8","WB9","WBS","WBP","WBD"],
    type: "sales",
    default_color: "WB0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "30BLW",
    name: "7.5 in. Number - Blue/Wht",
    fullname: "7.5 in. Numbers - Blue/White (12/pk)",
    colors: ["BLW0","BLW1","BLW2","BLW3","BLW4","BLW5","BLW6","BLW7","BLW8","BLW9","BLWS","BLWP","BLWD"],
    type: "sales",
    default_color: "BLW0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "30RW",
    name: "7.5 in. Numbers - Red/Wht",
    fullname: "7.5 in. Numbers - Red/White (12/pk)",
    colors: ["RW0","RW1","RW2","RW3","RW4","RW5","RW6","RW7","RW8","RW9","RWS","RWD","RWP"],
    type: "sales",
    default_color: "RW0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "90CBK",
    name: "9.5 in. Numbers - Char/Blk",
    fullname: "9.5 in. Numbers - Chartreuse/Black (12/pk)",
    colors: ["CBK0","CBK1","CBK2","CBK3","CBK4","CBK5","CBK6","CBK7","CBK8","CBK9","CBKS","CBKD"],
    type: "sales",
    default_color: "CBK0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "90BKHP",
    name: "9.5 in. Numbers - Bk/Htpk",
    fullname: "9.5 in. Numbers - Black/Hot Pink (12/pk)",
    colors: ["BKHP0","BKHP1","BKHP2","BKHP3","BKHP4","BKHP5","BKHP6","BKHP7","BKHP8","BKHP9","BKHPS","BKHPD","BKHPP"],
    type: "sales",
    default_color: "BKHP0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "90YB",
    name: "9.5 in. Numbers - Yllw/Blue",
    fullname: "9.5 in. Numbers - Yellow/Blue (12/pk)",
    colors: ["YB0","YB1","YB2","YB3","YB4","YB5","YB6","YB7","YB8","YB9","YBS","YBP","YBD"],
    type: "sales",
    default_color: "YB0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "90YR",
    name: "9.5 in. Numbers - Yllw/Red",
    fullname: "9.5 in. Numbers - Yellow/Red (12/pk)",
    colors: ["YR0","YR1","YR2","YR3","YR4","YR5","YR6","YR7","YR8","YR9","YRS","YRP","YRD"],
    type: "sales",
    default_color: "YR0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "11CBK",
    name: "11.5 in. Numbers - Chr/Blk",
    fullname: "11.5 in. Numbers - Chartreuse/Black (12/pk)",
    colors: ["CBK0","CBK1","CBK2","CBK3","CBK4","CBK5","CBK6","CBK7","CBK8","CBK9","CBKS","CBKP"],
    type: "sales",
    default_color: "CBK0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "11YB",
    name: "11.5 in. Number - Yllw/Blue",
    fullname: "11.5 in. Numbers - Yellow/Blue (12/pk)",
    colors: ["YB0","YB1","YB2","YB3","YB4","YB5","YB6","YB7","YB8","YB9","YBS","YBP","YBD"],
    type: "sales",
    default_color: "YB0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "11YR",
    name: "11.5 in. Number - Yllw/Red",
    fullname: "11.5 in. Numbers - Yellow/Red (12/pk)",
    colors: ["YR0","YR1","YR2","YR3","YR4","YR5","YR6","YR7","YR8","YR9","YRS","YRP","YRD"],
    type: "sales",
    default_color: "YR0",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "GP199",
    name: "Arch Slogans",
    fullname: "Arch Slogans - 2.75in. x 14in. (12/pk)",
    colors: ["Slogans","Red Yellow","Blue Yellow","Gold Black","Silver Black"],
    type: "sales",
    default_color: "Slogans",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "B17",
    name: "17 in. Latex Balloons",
    fullname: "17 in. Latex Balloons (72/bag)",
    colors: ["Black","Blue","Green","Orange","Red","Yellow","Pink","Purple","White","Gold","Silver","Assorted"],
    type: "sales",
    default_color: "Black",
    discount: [{ quantity: 72, price: 0.00 }],
    sizes: {
      72: 0.00,
    },
  },
  {
    code: "B36",
    name: "36 in. Latex Balloons",
    fullname: "36 in. Latex Balloons (10/bag)",
    colors: ["Blue","Green","Orange","Red","Yellow","White"],
    type: "sales",
    default_color: "Blue",
    discount: [{ quantity: 10, price: 0.00 }],
    sizes: {
      10: 0.00,
    },
  },
  {
    code: "CB55",
    name: "5.5 in. Rubber Balloons",
    fullname: "5.5 in. Rubber Chloroprene Balloons (1 ea)",
    colors: ["Blue","Green","Orange","Purple","Red","White","Yellow"],
    type: "sales",
    default_color: "Blue",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "RIBBON",
    name: "Balloon Ribbon (500 yrds)",
    fullname: "Balloon Ribbon (500 yards)",
    colors: ["Silver","White"],
    type: "sales",
    default_color: "Silver",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "STRING",
    name: "Cone of Balloon String",
    fullname: "Cone of Balloon String - 1500 yards",
    colors: ["White"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "PENLIN",
    name: "Triangle Pennants (100 FT)",
    fullname: "Triangle Pennants 48 - 12 in. x 18 in.",
    colors: ["Assorted","RWB"],
    type: "sales",
    default_color: "Assorted",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "BOW22",
    name: "22 in. Giant Bow",
    fullname: "22 in. Giant Magnetic Car Bow (2 ea)",
    colors: ["Blue","Gold","Green","Patriotic","Pink","Red","Silver","White","Red Grn"],
    type: "sales",
    default_color: "Blue",
    discount: [{ quantity: 2, price: 0.00 }],
    sizes: {
      2: 0.00,
    },
  },
  {
    code: "BOW30",
    name: "30 in. Giant Bow",
    fullname: "30 in. Giant Magnetic Car Bow (2 ea)",
    colors: ["Blue","Gold","Green","Patriotic","Pink","Red","Silver","White","Red Grn"],
    type: "sales",
    default_color: "Blue",
    discount: [{ quantity: 2, price: 0.00 }],
    sizes: {
      2: 0.00,
    },
  },
  {
    code: "HANG-HT-RDBK-TF",
    name: "Hang Tag - Red Tag Special",
    fullname: "Stock Hang Tags - Red Tag Special - 9in x 12in (50/pk)",
    colors: ["Fluorr"],
    type: "sales",
    default_color: "Fluorr",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-HT-RDBK-TG",
    name: "Hang Tag - Red Tag Sale",
    fullname: "Stock Hang Tags - Red Tag Sale - 9in x 12in (50/pk)",
    colors: ["Fluorr"],
    type: "sales",
    default_color: "Fluorr",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-BB",
    name: "Hang Tag - As Advertised",
    fullname: "Stock Hang Tags - As Advertised - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-FF",
    name: "Hang Tag - Financing Available",
    fullname: "Stock Hang Tags - Financing Available - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-SG",
    name: "Hang Tag - Was Now",
    fullname: "Stock Hang Tags - Was Now - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-MH",
    name: "Hang Tag - Sale",
    fullname: "Stock Hang Tags - Sale - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-CG",
    name: "Hang Tag - Clearance",
    fullname: "Stock Hang Tags - Clearance - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-HG",
    name: "Hang Tag - Like New",
    fullname: "Stock Hang Tags - Like New - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-LD",
    name: "Hang Tag - Per Month",
    fullname: "Stock Hang Tags - Per Month - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-SH",
    name: "Hang Tag - List Price",
    fullname: "Stock Hang Tags - List Price - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-NH",
    name: "Hang Tag - Special",
    fullname: "Stock Hang Tags - Special - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-TA",
    name: "Hang Tag - Blank w/outline",
    fullname: "Stock Hang Tags - Blank with outline - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-TE",
    name: "Hang Tag - Blank",
    fullname: "Stock Hang Tags - Blank - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-ME",
    name: "Hang Tag - Rebate",
    fullname: "Stock Hang Tags - Rebate - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "HANG-MF",
    name: "Hang Tag - Reduced",
    fullname: "Stock Hang Tags - Reduced - 9in x 12in (50/pk)",
    colors: ["Fluorg","Fluorp","Fluorr","Fluory"],
    type: "sales",
    default_color: "Fluorg",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.00,
    },
  },
  {
    code: "310",
    name: "File Number Labels",
    fullname: "File Right Number Labels (500/box)",
    colors: ["Number 0","Number 1","Number 2","Number 3","Number 4",
      "Number 5","Number 6","Number 7","Number 8","Number 9"],
    type: "sales",
    default_color: "Number 0",
    sizes: {
      500: 0.00,
    },
  },
  {
    code: "ALPLBL",
    name: "ABC Filing Labels",
    fullname: "Alphabetic File Right Labels (270/sheet)",
    colors: ["A","B","C","D","E","F","G","H","I","J","K","L","M",
      "N","O","P","Q","R","S","T","U","V","W","X","Y","Z","Mc"],
    type: "sales",
    default_color: "A",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "MONLBL",
    name: "Month Filing Labels",
    fullname: "File Right Month Labels (270/sheet)",
    colors: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
    type: "sales",
    default_color: "Jan",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "3196",
    name: "Certified Ovals",
    fullname: "Certified Ovals (12/pk)",
    colors: ["Style A","Style B","Style C","Style D","Style E","Style F"],
    type: "sales",
    default_color: "Style A",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "GP3185",
    name: "5 in. Stars",
    fullname: "5 in. Stars #GP3185 (12/pk)",
    colors: ["Blk Char","Blk Htpk","Blk Yllw","Blu Wht","Prp Char","Red Wht"],
    type: "sales",
    default_color: "Blk Char",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  }, 
  {
    code: "3192",
    name: "Blue Explosion Years",
    fullname: "7 in. x 9 in. Bright Blue Bursts (2000-2026 avail - 12/pk)",
    colors: ["Blue24", "Blue25","Blue26"],
    type: "sales",
    default_color: "Blue26",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  }, 
  {
    code: "3193",
    name: "Chartreuse Bursts",
    fullname: "9 in. x 11 in. Chartreuse Bursts (2000-2026 avail - 12/pk)",
    colors: ["Char24","Char25","Char26"],
    type: "sales",
    default_color: "Char26",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },  
  {
    code: "3184",
    name: "6 in. Happy Face",
    fullname: "6 in. Happy Face (12/pk)",
    colors: ["Happy"],
    type: "sales",
    default_color: "Happy",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  }, 
  {
    code: "GP150",
    name: "Happy Face Sunglasses",
    fullname: "6 in. Happy Face w/sunglasses (12/pk)",
    colors: ["Sunglasses"],
    type: "sales",
    default_color: "Sunglasses",
    discount: [{ quantity: 12, price: 0.00 }],
    sizes: {
      12: 0.00,
    },
  },
  {
    code: "GPBOX",
    name: "Numbers Box",
    fullname: "Numbers Box (holds 7.5 in x 9.5 in. numbers)",
    colors: ["White"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  }, 
  {
    code: "GP788",
    name: "Sticker",
    fullname: "Vehicle Not for Sale Sticker (100/pk)",
    colors: ["Yellow"],
    type: "sales",
    default_color: "Yellow",
    discount: [{ quantity: 100, price: 0.00 }],
    sizes: {
      100: 0.00,
    },
  },  
  {
    code: "GP790",
    name: "Sticker",
    fullname: "Vehicle Not for Sale Sticker (100/pk)",
    colors: ["Yellow"],
    type: "sales",
    default_color: "Yellow",
    discount: [{ quantity: 100, price: 0.00 }],
    sizes: {
      100: 0.0,
    },
  }, 
  {
    code: "AN651V1",
    name: "Sticker",
    fullname: "Vehicle Not for Sale Sticker (250/pk)",
    colors: ["Yellow"],
    type: "sales",
    default_color: "Yellow",
    discount: [{ quantity: 250, price: 0.00 }],
    sizes: {
      250: 0.0,
    },
  },
  {
    code: "GP611",
    name: "Sticker",
    fullname: "Smog OK Sticker (100/pk)",
    colors: ["White"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 100, price: 0.00 }],
    sizes: {
      100: 0.0,
    },
  },
  {
    code: "GP612",
    name: "Sticker",
    fullname: "Safety OK Sticker (100/pk)",
    colors: ["White"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 100, price: 0.00 }],
    sizes: {
      100: 0.0,
    },
  },
  {
    code: "280SH",
    name: "Hold/Sold Tag",
    fullname: "Hold/Sold Tag - 8.5 in x 11 in. (50/pk)",
    colors: ["Yellow"],
    type: "sales",
    default_color: "Yellow",
    discount: [{ quantity: 50, price: 0.00 }],
    sizes: {
      50: 0.0,
    },
  },
  {
    code: "DP830",
    name: "Hold/Sold Tag",
    fullname: "Hold/Sold Tag - 8 in x 4 in. (250/pk)",
    colors: ["Yellow"],
    type: "sales",
    default_color: "Yellow",
    discount: [{ quantity: 250, price: 0.00 }],
    sizes: {
      250: 0.0,
    },
  }, 
  {
    code: "3046",
    name: "Hold/Sold Tag (small)",
    fullname: "Hold/Sold Tag - 4.5 in x 2.5 in. (250/pk)",
    colors: ["Yellow"],
    type: "sales",
    default_color: "Yellow",
    discount: [{ quantity: 250, price: 0.00 }],
    sizes: {
      250: 0.0,
    },
  }, 
  {
    code: "GP839",
    name: "License Plate Envelope",
    fullname: "License Plate Envelope - 13 in x 6.5 in. (100/box)",
    colors: ["Kraft Paper"],
    type: "sales",
    default_color: "Kraft Paper",
    discount: [{ quantity: 100, price: 0.00 }],
    sizes: {
      100: 0.0,
    },
  }, 
  {
    code: "PB100",
    name: "Poly Bags",
    fullname: "Temp Tag Cover - Plastic (100/pk)",
    colors: ["Clear Plastic"],
    type: "sales",
    default_color: "Clear Plastic",
    discount: [{ quantity: 100, price: 0.00 }],
    sizes: {
      100: 0.0,
    },
  }, 
  {
    code: "TH100",
    name: "Temp L/P Protector",
    fullname: "License Plate Protector (100/pk)",
    colors: ["Clear"],
    type: "sales",
    default_color: "Clear",
    discount: [{ quantity: 100, price: 0.00 }],
    sizes: {
      100: 0.0,
    },
  },
  {
    code: "GP955",
    name: "Grease Markers",
    fullname: "Grease Marker (1 each)",
    colors: ["Blue","Green","Pink","Orange","Purple","Red","White","Yellow"],
    type: "sales",
    default_color: "Blue",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "957R",
    name: "Uni-Posca Markers (R)",
    fullname: "Regular Uni-Posca Marker (1 each)",
    colors: ["Green","Orange","Pink","Red","White","Yellow"],
    type: "sales",
    default_color: "Orange",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  }, 
  {
    code: "957L",
    name: "Uni-Posca Markers (L)",
    fullname: "LARGE Uni-Posca Marker (1 each)",
    colors: ["Blue","Pink","Red","White","Yellow"],
    type: "sales",
    default_color: "Blue",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  },                                                
  {
    code: "3088",
    name: "Floor Mats",
    fullname: "Floor Mats/Coated Paper (500/bx)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    discount: [{ quantity: 500, price: 0.00 }],
    sizes: {
      500: 0.0,
    },
  },
  {
    code: "55010",
    name: "Steering Wheel Covers",
    fullname: "Steering Wheel Covers (500/bx)",
    colors: ["Plastic"],
    type: "service",
    default_color: "Plastic",
    discount: [{ quantity: 500, price: 0.00 }],
    sizes: {
      500: 0.0,
    },
  },
  {
    code: "600088B",
    name: "Seat Covers (box)",
    fullname: "The Gripper Plastic Seat Covers (250/box)",
    colors: ["Plastic"],
    type: "service",
    default_color: "Plastic",
    discount: [{ quantity: 250, price: 0.00 }],
    sizes: {
      250: 0.0,
    },
  },  
  {
    code: "600088V",
    name: "Seat Covers (roll)",
    fullname: "No-Slip Plastic Seat Covers (500/roll)",
    colors: ["Plastic"],
    type: "service",
    default_color: "Plastic",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      500: 0.0,
    },
  }, 
  {
    code: "6000D",
    name: "Seat Cover Floor Stand",
    fullname: "Seat Cover Floor Stand",
    colors: ["Black"],
    type: "service",
    default_color: "Black",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.0,
    },
  }, 
  {
    code: "6000WD",
    name: "Seat Cover Wall Dispenser",
    fullname: "Seat Cover Wall Dispenser",
    colors: ["Black"],
    type: "service",
    default_color: "Black",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.0,
    },
  }, 
  {
    code: "3044",
    name: "Spring Rings",
    fullname: "Metal Spring Rings (250/pk)",
    colors: ["Metal"],
    type: "service",
    default_color: "Metal",
    discount: [{ quantity: 250, price: 0.00 }],
    sizes: {
      250: 0.00,
    },
  },
  {
    code: "EIT50",
    name: "Self-Locking Key Tags",
    fullname: "Self-Locking Key Tags (1000/pk)",
    colors: ["Blue","Green","Orange","Red","Yellow","White"],
    type: "service",
    default_color: "Blue",
    sizes: {
      1000: 0.00,
    },
  },         
  {
    code: "SDNRG",
    name: "Service Numbers",
    fullname: "Service Dispatch Numbers (1000/bx)",
    colors: ["_0000","1000","2000","3000","4000","5000",
      "6000","7000","8000", "9000"],  
    type: "service",
    default_color: "1000",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.0,
    },
  }, 
  {
    code: "SDNC",
    name: "Service Numbers",
    fullname: "Mirror Hang Service Numbers (1000/bx)",
    colors: ["Blue","Green","Grey","Lime","Orange","Pink","Purple","Red","Tan","White","Yellow"],  
    type: "service",
    default_color: "Blue",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.0,
    },
  }, 
  {
    code: "SDN0000",
    name: "Service Numbers",
    fullname: "Mirror Hang Service Numbers (1000/bx)",
    colors: ["_0000","1000","2000","3000","4000","5000",
      "6000","7000","8000", "9000"],  
    type: "service",
    default_color: "1000",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.0,
    },
  }, 
  {
    code: "SDN999",
    name: "Service Numbers",
    fullname: "Mirror Hang Service Numbers (000-999) (1000/bx)",
    colors: ["White"],  
    type: "service",
    default_color: "White",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.0,
    },
  },
  {
    code: "230",
    name: "Colored Dispatch Numbers",
    fullname: "Colored Dispatch Numbers (1000/pk)",
    colors: ["Blue","Green","Red","White","Yellow"],  
    type: "service",
    default_color: "Blue",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.0,
    },
  },   
  {
    code: "BGVinyl",
    name: "Vinyl Sheet",
    fullname: "8.5 x 11 Blank Vinyl Sheet #9300 (100/pk)",
    colors: ["White"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      default: 0.00,
    },
  },
  {
    code: "BGE12-AL",
    name: "Buyers Guide",
    fullname: "Buyers Guide, Blank Front (100/pk)",
    colors: ["White"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      default: 0.00,
    },
  },
   {
    code: "3198WB",
    name: "Oval Year Stickers",
    fullname: "Oval Year Stickers - Blue/White (12/pk)",
    colors: ["YR 07","YR 08","YR 09","YR 10","YR 11","YR 12","YR 13","YR 14","YR 15","YR 16",
     "YR 17","YR 18","YR 19","YR 20","YR 21","YR 22", "YR 23", "YR 24","YR 25", "YR 26"],
    type: "sales",
    default_color: "YR 07",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "3198SB",
    name: "Oval Year Stickers",
    fullname: "Oval Year Stickers - Silver/Black (12/pk)",
    colors: ["YR 2016", "YR 2017","YR 2018","YR 2019","YR 2020",
     "YR 2021","YR 2022","YR 2023","YR 2024", "YR 2025","YR 2026"],   
    type: "sales",
    default_color: "YR 2016",
    discount: [{ quantity: 1, price: 0.00 }],
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "3198BY",
    name: "Oval Year Stickers",
    fullname: "Oval Year Stickers (Black/Yellow)  (12/pk)",
    colors: ["BY_08","BY_09","BY_10","BY_11","BY_12","BY_13","BY_14","BY_15","BY_16",
      "BY_17","BY_18","BY_19","BY_20","BY_21","BY_22","BY_23","BY_24","BY_25","BY_26"],
    type: "sales",
    default_color: "BY 08",
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "NDESTOCK",
    name: "Night Drop Envelopes",
    fullname: "Night Drop Envelopes (500/bx)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      500: 0.00,
    },
  },
  {
    code: "7290",
    name: "Inspection Form - 3 Part",
    fullname: "Multi-Point Inspection Form - 3 Part (250/pk)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      250: 0.00,
    },
  },
  {
    code: "7291",
    name: "Inspection Form - 2 Part",
    fullname: "Multi-Point Inspection Form - 2 Part (250/pk)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      250: 0.00,
    },
  },
  {
    code: "7292",
    name: "Inspection Form - GM",
    fullname: "Multi-Point Inspection Form (GM) 3 Part (250/pk)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      250: 0.00,
    },
  },
  {
    code: "7293",
    name: "Inspection Form CHRYSLER",
    fullname: "Multi-Point Inspection Form (Chrysler) 3 Part (250/pk)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      250: 0.00,
    },
  },
  {
    code: "TICKETHOLDER",
    name: "Work Ticket Holders",
    fullname: "Neon Stitched Work Ticket Holders",
    colors: ["Black","Blue","Green","Orange","Pink","Red","Yellow"],
    type: "service",
    default_color: "Black",
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "7320",
    name: "Night Drop Box",
    fullname: "Self-Contained Night Drop Box",
    colors: ["Black"],
    type: "service",
    default_color: "Black",
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "7321",
    name: "Night Drop Box Posts",
    fullname: "24in. Surface Mount Post for Drop Box",
    colors: ["Black"],
    type: "service",
    default_color: "Black",
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "7322",
    name: "Night Drop Box Posts",
    fullname: "36in. In Ground Mount Post for Drop Box",
    colors: ["Black"],
    type: "service",
    default_color: "Black",
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "GCAPS",
    name: "Control Caps",
    fullname: "Magnetic Control Caps 10in. x 10in. x 5 in.",
    colors: ["Slogans","Black","Blue","Green","Grey","Orange","Purple","Red","Tan","White","Yellow"],
    type: "service",
    default_color: "Slogans",
    sizes: {
      1: 0.00,
    },
  },
  {
    code: "GUARDFRM",
    name: "Zinc Metal Frames",
    fullname: "Zinc Metal Frame",
    colors: ["Metal"],
    type: "customs",
    default_color: "Metal",
    supportedStores: ["GUAPRO"],
    sizes: {
      500: 0.0,
      1000: 0.0,
      2500: 0.0,
    },
  },
  {
    code: "guardianpp",
    name: "Poly Coated Plates",
    fullname: "Poly Coated Cardboard w/blue imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["GUAPRO"],
    sizes: {
      500: 0.0,
      1000: 0.0,
      2500: 0.0,
    },
  },
  {
    code: "GUARDECAL",
    name: "Die Cut Decals",
    fullname: "Vinyl Diecut Decals",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["GUAPRO"],
    sizes: {
      500: 0.0,
      1000: 0.0,
      2500: 0.0,
    },
  },
];
